module.exports = "<div [class.loader-hidden]=\"!show\">\n    <div class=\"loader-overlay\">\n            <div>\n                <!-- <md-progress-bar mode=\"indeterminate\" *ngIf=\"show\"></md-progress-bar> -->\n            </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-page/loader/loader.component.html
// module id = ./src/app/home-page/loader/loader.component.html
// module chunks = main